import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      <Route path='/quote/get-quote/:type' component={Loadable(() => import('./GetQuote'))} />
      <Route path='/quote' component={Loadable(() => import('./Quote.container'))} />
    </Switch>
  )
}

export default routes
